import trim from 'lodash/trim';
import once from 'lodash/once';
import over from 'lodash/over';
import isFunction from 'lodash/isFunction';
import isArray from 'lodash/isArray';
import EE from './EE';
import { getFirstArgFromString, replaceFirstTagAttrs, hasFirstTag, insertClassIntoAttrStr } from './utils';



let idCounter = 0;

export const renderTo = (component, element, init) => {
  if (!element) {
    return;
  }

  element.insertAdjacentHTML('beforeEnd', component.toString());

  setTimeout(() => {
    component.init();

    if (init) {
      init();
    }
  }, 15);
};

/**
 * @param {Function} [bootstrap]
 * @param {Function} template
 * @param {Function} [onInit]
 * @returns {Function}
 * */
export default (bootstrap, template, onInit) => {
  if (bootstrap == null) {
    bootstrap = (data) => data;
  }

  return (componentName = null, parentData = {}, parentEE = EE()) => {
    let data = {};
    const [ eventBus, destroyEventBus ] = parentEE.wrap();
    const components = [];
    let onDestroy = () => {};



    // nested component
    const $cmp = (componentName, componentBuilder, nestedData = {}, nestedEventBus = eventBus) => {
      const cmp = componentBuilder(componentName, nestedData, nestedEventBus);

      components.push(cmp);

      return cmp;
    };



    // component
    let id = null;

    const toString = () => {
      data = bootstrap({ ...parentData });

      const html = trim(template($cmp, data));

      if (!hasFirstTag(html)) {
        throw TypeError('invalid html format. It must have first tag');
      }

      return replaceFirstTagAttrs(html, (attrsStr) => {
        if (componentName) {
          attrsStr = insertClassIntoAttrStr(attrsStr, componentName);
        }

        id = getFirstArgFromString(attrsStr);

        id = `cmp-${++idCounter}`;

        attrsStr = ` id="${id}" ${attrsStr}`;

        return attrsStr;
      });
    };



    let destroyed = 0;

    const destroy = () => {
      if (destroyed++) {
        return;
      }

      while (components.length) {
        components.pop().destroy();
      }

      const element = document.getElementById(id);

      if (element) {
        element.parentNode.removeChild(element);
      }

      onDestroy();

      destroyEventBus();
    };



    let initialized = 0;

    const init = () => {
      if (initialized++) {
        return;
      }

      if (onInit) {
        const _onDestroy = onInit(document.getElementById(id), data, { $on: eventBus.on, $emit: eventBus.emit, $wrap: eventBus.wrap, id, destroy });

        if (isFunction(_onDestroy)) {
          onDestroy = once(_onDestroy);
        } else if (isArray(_onDestroy)) {
          onDestroy = once(over(_onDestroy));
        }
      }

      components.forEach((cmp) => {
        cmp.init();
      });
    };



    return { toString, init, destroy };
  };
};



// WEBPACK FOOTER //
// ./src/lib/cmp/index.js